module.exports = __webpack_public_path__ + "img/monitor5.93f32de2.jpg";